/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
//import {Dropdown1} from '../../../../../_metronic/partials/content/dropdown/Dropdown1'
//import {KTSVG} from '../../../../../_metronic/helpers'
//import { getCredential } from '../../../../services/credentialService'
//import { CreateAppModal } from '../../../../../_metronic/partials'
//import { ModalCreateCredential } from '../modalCreateCredential'
import { Link } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../../../modules/auth'
import { getCredential } from '../../../services/credentialService'
import { getplantsAll } from '../../../services/plantsService'
import { ModalCreateCredential } from '../components/modalCreateCredential'
import { ModalDeleteCredential } from '../components/ModalDeleteCredential'
import { LoadingSpan } from '../../components/Loadings/loadingSpan'
import styles from './myPortal.module.css'

type Props = {
  className: string
  color: string
  mark: any;
  credentials: any
  refreshCredentials: any
  companyId?: string
}

const MyPortal: React.FC<Props> = ({className, color, mark, credentials, refreshCredentials, companyId}) => {
    //const [credentials, setCredentials] = useState<any>([]);
    const [plants, setPlants] = useState<any>([]);
    const [credentialLoading, setCredentialLoading] = useState<any>(true);
    const [setPlantsLoading] = useState<any>(true);
    const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
    const [showDeleteAppModal, setShowDeleteAppModal] = useState<boolean>(false)
    const [myCredential, setMyCredential] = useState<any>(null);
    const user = useAuth()
    
    const getCredentials = async () => {
      try {
        setCredentialLoading(true)
        // const myCredentials = await getCredential(mark.sub_name)
        // setCredentials(myCredentials)
        setCredentialLoading(false)

      } catch (error) {
        console.log(error)
      }
    }

    const getPlants = async () => {
      try {
        setPlantsLoading(true)
        const myPlants = await getplantsAll(`?mark=${mark.id}`)
        setPlants(myPlants)
        setPlantsLoading(false)

      } catch (error) {
        console.log(error)
      }
    }

    const refresh = async () => {
      refreshCredentials()
    }

    const eventEdit = (credential: any) => {
      setMyCredential(credential)
      setShowCreateAppModal(true)
    }

    const eventDelete = (credential: any) => {
      setMyCredential(credential)
      setShowDeleteAppModal(true)
    }


    useEffect(() => {
      getCredentials()
      if(user.currentUser?.role.slug === "CLIENTE"){
        getPlants()
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
  return (
    <div className={`card ${className}`} style={{height: '100%'}}>
      <div className='card-body p-0 d-flex flex-column'>
        <div className={`px-6 pt-6 card-rounded h-100px w-100 flex-shrink-0 bg-${color}`}>
          <div className='d-flex flex-stack'>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <div className='symbol symbol-30px me-4 p-1 bg-light' >
                {mark && mark.link_imagem ? 
                  (<img
                      src={toAbsoluteUrl(`${mark.link_imagem}`)}
                      className=''
                      alt=''
                  />) 
                  :
                  (<KTSVG path='/media/icons/duotune/coding/cod009.svg' className='svg-icon-2x svg-icon-dark'/>)}
              </div>
              <h3 className='m-0 text-light fw-bold fs-4'>{mark.name}</h3>
            </div>
            
            <div className='ms-1' style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                {mark.portal_url &&
                  <a
                    href={mark.portal_url}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='d-flex align-items-center opacity-75-hover'
                    data-bs-toggle='tooltip'
                    title='Abrir portal original'
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2x svg-icon-light' />
                  </a>
                }

                <div style={{height: '2rem', width: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <div className={`bg-${
                    mark.active ? "success" : "danger"
                  } rounded-circle h-15px w-15px`}></div>
                </div>
            </div>
          </div>
        </div>

        <div
          className='shadow-xs card-rounded mx-4 mb-6 px-5 py-8 position-relative z-index-1 bg-body d-flex flex-column flex-grow-1'
          style={{marginTop: '-30px'}}
        >
          {/* begin::Item */}
            <div className={styles.credentialsList} style={{maxHeight: '12rem', marginBottom: '0.7rem', overflow: 'auto'}}>
              {
                user.currentUser?.role.slug === "CLIENTE" ?
                  <div style={{marginRight: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                    {
                      plants.length > 0 ?
                        plants.map((plant: any) => {
                          return (
                            <div className='d-flex align-items-center' style={{flex: '1', overflow: 'auto'}}>
                              <div className='d-flex align-items-center'>
                                <div className='symbol symbol-50px me-5'>
                                  <img
                                      src={toAbsoluteUrl('/media/imgs/plant2.png')}
                                      className=''
                                      alt=''
                                  />
                                </div>
                              </div>
                              <div className='mb-1 pe-3 flex-grow-1'>
                                <Link to={`#`} className='fs-7 text-gray-800 text-hover-primary fw-bold'>
                                    {plant.name}
                                </Link> 
                                {/* <div className='text-gray-400 fw-semibold fs-7'>***************</div> */}
                              </div>
                        
                            </div>
                          );
                        })
                      :
                        <div className='d-flex align-items-center' style={{flex: '1', overflow: 'auto'}}>
                          <span>Não há usinas nesse portal!</span>
                        </div>
                    }
                  </div>
                :
              !credentialLoading ? 
                      //mark && mark.credentials && mark.credentials.length > 0 ?
                       //mark.credentials.map((credential: any) => {
                       credentials && credentials.length > 0 ?
                       credentials.map((credential: any) => {
                          return (
                              <div key={credential.id} className='d-flex align-items-center mb-4' style={{gap: '0.7rem', alignItems: 'center'}}>
                                  <div className='d-flex align-items-center flex-wrap' style={{flex: '1', overflow: 'auto'}}>
                                      <div className='pe-3 flex-grow-1'>
                                        <Link to={`/portals/plantImported/${credential.id}`} className='fs-7 text-gray-800 text-hover-primary fw-bold'>
                                            {credential.username}
                                        </Link> 
                                        <div className='text-gray-400 fw-semibold fs-7'>***************</div>
                                      </div>
                                      <div className='d-flex align-items-center'>
                                      {/* <div className='fw-bold fs-7 text-gray-800 pe-1'>( 1 )</div> */}

                                      </div>
                                  </div>

                                  {
                                    credential 
                                    && credential.errosCount !== null 
                                    && credential.errosCount > 3 &&
                                      <span 
                                        className='menu-title'
                                        data-bs-toggle='tooltip'
                                        title={credential.descriptionErrors ? credential.descriptionErrors : ""}
                                      >
                                        <KTSVG 
                                          path='/media/icons/duotune/general/gen044.svg' 
                                          className='svg-icon-2 svg-icon-2x text-danger text-hover-primary cursor-pointer'
                                        />
                                      </span>
                                  }

                                  <div className='d-flex align-items-center flex-shrink-0' style={{gap: '0.4rem'}}>
                                    <button
                                      type='button'
                                      className='btn btn-icon btn-sm btn-light-primary w-30px h-30px'
                                      title='Editar credencial'
                                      onClick={() => eventEdit(credential)}
                                    >
                                      <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-4' />
                                    </button>
                                    <button
                                      type='button'
                                      className='btn btn-icon btn-sm btn-light-danger w-30px h-30px'
                                      title='Excluir credencial'
                                      onClick={() => eventDelete(credential)}
                                    >
                                      <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-4' />
                                    </button>
                                  </div>
                              </div>
                              
                      )})
                      : 
                      <div className='d-flex align-items-center mb-6'>
                          <span>Não há credenciais para esse portal.</span>
                      </div>
              : 
                <div className='d-flex align-items-center mb-6'>
                  <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                </div>
              }
            </div>

            {user.currentUser?.role.slug !== "CLIENTE" ?
              <button 
                className={`btn btn-primary w-100 py-3 fs-7 mt-auto`}
                //disabled={mark.active && credentials.length === 0 ? false : true}
                disabled={mark.active ? false : true}
                onClick={() => setShowCreateAppModal(true)}
              >
                Adicionar credencial
              </button>
              : <></>
            }
            
            

        </div>
        {/* end::Items */}
      </div>
      {/* end::Body */}
      <ModalCreateCredential 
        show={showCreateAppModal}
        id={myCredential && myCredential.id ? myCredential.id : undefined} 
        handleClose={() => {
          setMyCredential(null)
          setShowCreateAppModal(false)
          refresh()
        }} 
      mark={mark}
      companyId={companyId}
      />

      <ModalDeleteCredential 
        show={showDeleteAppModal}
        data={myCredential}
        id={myCredential && myCredential.id ? myCredential.id : undefined} 
        handleClose={() => {
          setMyCredential(null)
          setShowDeleteAppModal(false)
          refresh()
        }} 
      />
    </div>
  )
}

export {MyPortal}

// function toggleToast(arg0: string, arg1: string) {
//   throw new Error('Function not implemented.')
// }

